import axios from 'axios';
import {ApiClientFactory} from '@dealer-group/dealerui';

const client = ApiClientFactory(axios, {baseURL: process.env.VUE_APP_DX_URL || null});

export default client;
